// extracted by mini-css-extract-plugin
export var actionButton = "_c4-0";
export var attachmentLine = "_c4-1";
export var fileInput = "_c4-2";
export var fileUploadWrapper = "_c4-4";
export var footer = "_c4-3";
export var modalContent = "_c4-5";
export var paperclip = "_c4-6";
export var quillEditor = "_c4-7";